import SettingsMixin from "./SettingsMixin";

// Dieses Mixin ist eine dynamische Klasse. Sie wrappt alle Funktionen des Settingsmixin
// Dabei checkt Sie aber die jeweiligen Modelle, und geht im Default auf das 'Standard'-Modell
export class SchrankSettingsMixin {
    constructor(modell) {
        this.MODELL = modell;
    }
}
 
for(const functionName of Object.getOwnPropertyNames(SettingsMixin.prototype)) {
    const settingsMethod = SettingsMixin.prototype[functionName];
    SchrankSettingsMixin.prototype[functionName] = function(key, ...args) {

        if(this[key]) {
            return settingsMethod.call(APP.options[this.MODELL], key, ...args);
        } else {
            return settingsMethod.call(APP.options['Standard'], key, ...args);
        }
        
    }
}